import _difference from 'lodash/difference'
const getLocalState = (state) => state.clone
export const getCanDuplicate = (state) => {
  // Check against current selection if a duplication of the last cloning is available.
  const selection = state.selection.selection
  const uuids = getLocalState(state).uuids
  return !!uuids.length && _difference(selection, uuids).length === 0
}
